<template>
  <div class="jContainer" :class="{'jContainerExpanded' :  rowState.expanded }">
    <div
      class="tr"
      @click="clickedRowAction(trItem['.key'])"
      @contextmenu="rightClickHandler($event,trItem['.key'])"
    >
      <div
        class="borderAction"
        :style="{'background-color' : trItem.state === undefined ? 'gray' : stati[trItem.state].color}"
        :class="{'borderActionHover': rowState.hovered, 'animated' : enableAnimations }"
        @mouseenter="rowState.hovered = true"
        @mouseleave="rowState.hovered = false"
      >
        <button v-if="rowState.hovered" @click.stop="rowState.expanded = ! rowState.expanded">A</button>
        <button v-if="rowState.hovered">B</button>
        <button v-if="rowState.hovered">C</button>
        <button v-if="rowState.hovered">D</button>
      </div>
      <div
        :key="td.key"
        v-for="td in config.tableRowsConfig"
        style="flex-direction:column;"
        class="d-flex justify-content-center"
        :style="td.style"
      >
        {{trItem[td.string]}}
        {{td.key}}
        <div v-html="td.html"></div>
        <div :trItem="trItem" :config="config" :is="td.componentName"></div>
        <div v-for="child of td.children" :key="child.index">
          <span :style="child.style">{{trItem[child.string]}}</span>
          <div v-html="child.html"></div>
          <div :trItem="child.componentName" :is="child.componentName"></div>
        </div>
      </div>
      <crudTableContextualMenu
        v-if="$store.state.crudTableStates.rightClickedRow === trItem['.key']"
        :config="config"
        :contextualMenu="$store.state.crudTableStates.contextualMenu"
        :trItem="trItem"
      ></crudTableContextualMenu>
    </div>

    <div v-show="rowState.expanded" class="jContanerHiddenArea">{{trItem}}</div>
  </div>
</template>

<script>
import { ref } from "@/components/puntatori";
import { EventBus } from "../main.js";
import Vue from "vue";
import { mapState, mapGetters } from "vuex";

export default {
  name: "crudTableRow",
  directives: {},
  props: ["config", "trItem"],
  data() {
    return {
      elementType: "row", // o quadrat
      rowState: {
        hovered: false,
        selected: false,
        clicked: false,
        rightClicked: false,
        expanded: false,
        enableAnimations: false
      }
    };
  },
  computed: {
    ...mapGetters({
      stati: "ordineStates/stati"
    })
  },
  methods: {
    sospendiAnimazione() {
      //DISATTIVA LE ANIMAZIONI PER 2 SECONDI
      //RICHIAMATO CON UN WATCH SU TRITEM
      //E ONCREATED
      //IL WATCH SERVE PERCHE ORDINANDO LA LISTA AL CONTRARIO
      //GLI ELEMENTI DEL DOM SHIFTANO OGNI VOLTA
      //E IL TRITEM DI RIFERIMENTO CAMBIA
      let self = this;
      self.enableAnimations = false;
      setTimeout(function() {
        self.enableAnimations = true;
      }, 2000);
    },
    rightClickHandler(event, key) {
      var self = this;
      this.$store.commit("crudTableStates/rightClickedRow", key);
      this.$store.commit("crudTableStates/setContextualMenu", event);
      //dopo 5 secondi disabilito il menu laterale.
      //killare i timeout vecchi prima
      /* setTimeout(function() {
        self.$store.commit("crudTableStates/rightClickedRow", "");
        self.$store.commit("crudTableStates/setContextualMenu", {});
      }, 5000);*/
      event.preventDefault();
    },
    clickedRowAction(key) {
      if (this.$store.state.crudTableStates.rightClickedRow !== "") {
        this.$store.commit("crudTableStates/rightClickedRow", "");
        this.$store.commit("crudTableStates/setContextualMenu", {});
      } else if (key !== undefined) {
        //BRENNO COMMENTATO APERTURA TENDINA CLICK SU ROW
        //this.$router.push(this.$route.path + "?id=" + key);
        //EventBus.$emit("stato_tendina", true);
      } else console.log(this.$options.name + "-" + "key non definita");
    }
  },
  mounted() {},
  created() {
    this.sospendiAnimazione();
  },
  watch: {
    trItem: function(newValue, oldValue) {
      this.sospendiAnimazione();
    }
  }
};
</script>

<style lang="scss" scoped>
$borderActionHover: 0.18s;

.animated {
  -webkit-transition: background 0.4s ease-out 0.2s;
  -moz-transition: background 0.4s ease-out 0.2s;
  -o-transition: background 0.4s ease-out 0.2s;
  transition: background 0.4s ease-out 0.2s;
}

.jContainer {
  background-color: white;
  margin-left: 2.1vw;
  margin-right: 2.1vw;
  margin-bottom: 1vh;
}

.jContainerExpanded {
  background-color: #099300;
  color: Red;
  margin-bottom: 5vh;
}

.jContanerHiddenArea {
  background-color: white;
  transition: all 0.5s ease-in-out;
}

.tr {
  display: flex;
  background-color: inherit;
  height: 12vh;
  overflow: hidden;
  z-index: 9999999;
  -webkit-box-shadow: 1px 1px 2px 0px rgba(0, 0, 0, 0.21);
  -moz-box-shadow: 1px 1px 2px 0px rgba(0, 0, 0, 0.21);
  box-shadow: 1px 1px 2px 0px rgba(0, 0, 0, 0.21);
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
}

.borderAction {
  width: 0.5vw;
}

.borderAction button {
  margin-right: 1vw;
  float: right;
}

.borderActionHover {
  width: 5vw;
  -moz-transition: width $borderActionHover ease-in-out,
    left $borderActionHover ease-in-out;
  -webkit-transition: width $borderActionHover ease-in-out,
    left $borderActionHover ease-in-out;
  -moz-transition: width $borderActionHover ease-in-out,
    left $borderActionHover ease-in-out;
  -o-transition: width $borderActionHover ease-in-out,
    left $borderActionHover ease-in-out;
  transition: width $borderActionHover ease-in-out,
    left $borderActionHover ease-in-out;
}
</style>
